import { __rest, __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var AnalyticsFilled = function (_a) {
  var _b = _a.fill,
    fill = _b === void 0 ? 'currentColor' : _b,
    props = __rest(_a, ["fill"]);
  return React__default.createElement("svg", __assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M14.1962 2L10.4989 5.6973L7.91516 3.11356L3 8.02873L4.21786 9.24658L7.91516 5.54928L10.4989 8.13302L15.4141 3.21786L14.1962 2Z",
    fill: fill
  }), React__default.createElement("path", {
    d: "M14.3132 6C13.8968 6 13.5589 6.33789 13.5589 6.75421V17.3132C13.5589 17.7295 13.8968 18.0674 14.3132 18.0674H16.5758C16.9921 18.0674 17.33 17.7295 17.33 17.3132V6.75421C17.33 6.33789 16.9921 6 16.5758 6H14.3132ZM9.03368 9.01684C8.61736 9.01684 8.27947 9.35473 8.27947 9.77105V17.3132C8.27947 17.7295 8.61736 18.0674 9.03368 18.0674H11.2963C11.7126 18.0674 12.0505 17.7295 12.0505 17.3132V9.77105C12.0505 9.35473 11.7126 9.01684 11.2963 9.01684H9.03368ZM3.75421 12.0337C3.33789 12.0337 3 12.3716 3 12.7879V17.3132C3 17.7295 3.33789 18.0674 3.75421 18.0674H6.01684C6.43317 18.0674 6.77105 17.7295 6.77105 17.3132V12.7879C6.77105 12.3716 6.43317 12.0337 6.01684 12.0337H3.75421Z",
    fill: fill
  }));
};
export { AnalyticsFilled as default };
//# sourceMappingURL=AnalyticsFilled.js.map
